import { createBrowserHistory } from 'history';

export default {
  HOMEPAGE: '/',
  LOGIN: '/login',
  PASSWORD_RESET: '/reset-password/:userId/:token',
  TRIAL_EXPIRED: '/trial-expired',
  QUESTIONNAIRE: {
    BASE: '/questionnaire',
    MAIN: '/:portfolio/questionnaire'
  },
  CASE: {
    BASE: '/case',
    EDIT: '/case/:portfolio/edit'
  },
  CASES: '/cases',
  RISK_SUMMARY: {
    BASE: '/risk-summary',
    MAIN: '/:portfolio/risk-summary/'
  },
  EXISTING_POLICIES: {
    BASE: '/existing-policies',
    MAIN: '/:portfolio/existing-policies',
    MANAGE_POLICIES: '/:portfolio/existing-policies/manage-policies',
    POLICY_SUMMARY: '/:portfolio/existing-policies/policy-summary',
    POLICY_ANALYSIS: '/:portfolio/existing-policies/policy-analysis',
    IO_IMPORT_POLICIES:
      '/:portfolio/existing-policies/intelligent-office-import'
  },
  RECOMMENDATIONS: {
    BASE: '/recommendations',
    MAIN: '/:portfolio/recommendations',
    PORTFOLIO_BUILDER: '/:portfolio/recommendations/portfolio-builder/:policyId'
  },
  ADVISOR_CHARGES: {
    BASE: '/advisor-charges',
    MAIN: '/:portfolio/advisor-charges'
  },
  IPS: {
    BASE: '/ips',
    MAIN: '/:portfolio/ips',
    PRINT: '/:portfolio/ips/print'
  },
  CFL_QUESTIONNAIRE: '/:portfolio/:customer/capacity-for-loss',
  EXP_QUESTIONNAIRE: '/:portfolio/:customer/experience-questions',
  SURVEY: '/survey/:token',
  RISK_MAPPING: '/risk-mapping',
  CIP_MANAGEMENT: '/cip-management',
  PROVIDER_PLATFORM_CHARGES: '/provider-platform-charges',
  SETTINGS: '/settings',
  INVESTMENT_ANALYSER: '/investment-analyser',
  USER_SETTINGS: '/user-settings',
  GLOSSARY: '/glossary',
  MPS_HUB: {
    BASE: '/mps-hub',
    PROVIDER: '/mps-hub/:provider',
    PROVIDER_EDIT: '/mps-hub/:provider/edit'
  }
};

export const history = createBrowserHistory();
